import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { AssetService } from "./asset-service.entity";

@Entity('asset_service_upload')
export class AssetServiceUpload {
    @PrimaryGeneratedColumn("increment", { name: 'upload_id' })
    uploadId: number;


    @Column("varchar", {
        nullable: false,
        name: "maintenance_name",
        length: 50
    })
    maintenanceName: string | null;

    @Column("varchar", {
        nullable: true,
        name: "serve_id",
        length: 50
    })
    serveId: string | null;

    @Column("varchar", {
        nullable: true,
        name: "file_name",
        length: 50
    })
    fileName: string | null;

    @Column("varchar", {
        nullable: true,
        name: "file_path",
        length: 50
    })
    filePath: string | null;

    @Column("boolean", {
        nullable: false,
        name: "is_active",
        default: true
    })
    isActive: boolean | null;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

}